<template>
	<div class="filters-box-row">
		<div class="filters-container" :style="collapse ? 'height: 50px' : ''">
			<div class="input-box">
				<span>员工名称：</span>
				<el-input
					v-model="name"
					placeholder="员工名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>员工手机号：</span>
				<el-input
					v-model="phone"
					placeholder="员工手机号"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>员工状态：</span>
				<el-select v-model="status" class="name-input" size='mini' placeholder="员工状态">
					<el-option :value="0" label="全部"></el-option>
					<el-option :value="1" label="启用"></el-option>
					<el-option :value="2" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>员工类型：</span>
				<el-select v-model="usertype" class="name-input" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="内控"></el-option>
					<el-option :value="1" label="业务"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>是否接收消息：</span>
				<el-select v-model="subscriptionSendFlag" class="name-input" size='small'>
					<el-option value="" label="全部"></el-option>
					<el-option :value="true" label="是"></el-option>
					<el-option :value="false" label="否"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>员工权限：</span>
				<el-select v-model="role" class="name-input" size='mini' placeholder="员工权限">
					<el-option :value="0" label="全部"></el-option>
					<el-option v-for="item in roleData" :value="item.id" :label="item.name" :key="item.id"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>适用门店：</span>
				<el-select v-model="sIds" multiple collapse-tags class="name-input" size='mini' placeholder="适用门店">
					<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="search-right-wrap">
			<el-button size="small" type="text" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
			<el-button
				type="primary"
				class="btn fx-btn"
				size="small"
				@click="onSearch">查询</el-button>
			<el-button
				class="btn fx-btn"
				size="small"
                plain
				@click="clearing">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	props: {
		orderKey: Number,
		time: Array
	},
	data () {
		return {
			subscriptionSendFlag: '',
			usertype: -1,
			shopid: -1,
			collapse: false,
			status: 0,
			name: '',
			phone: '',
			shopData: [{ name: '全部', id: -1 }],
			roleData: [],
			role: 0,
			shopList: [],
			sIds: []
		}
	},
	created () {
		this.getShop()
		this.getRole()
	},
	methods: {
		findShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findshopbysyscode`
			}).then(res => {
				if (res.result) {
					// this.shopid = -1
					// let all = [{ name: '全部', id: -1 }]
					this.shopData = this.shopData.concat(res.data)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getRole () {
			let params = {
				rInfo: '',
				rtype: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/authority/getRole`,
				data: params
			}).then(res => {
				if (res.result) {
					// this.shopid = -1
					// let all = [{ name: '全部', id: -1 }]
					this.roleData = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			}).catch(() => {
			})
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		clearing () {
			this.status = 0
			this.usertype = -1
			this.shopid = -1
			this.name = ''
			this.phone = ''
			this.sIds = []
			this.subscriptionSendFlag = ''
			this.role = 0
			this.onSearch()
		},
		onSearch () {
			let params = {
				staffName: this.name,
				usertype: this.usertype,
				staffDisabled: this.status,
				tel: this.phone,
				sIds: this.sIds,
				page: 1,
				size: 20,
				shopid: this.shopid,
				roleid: this.role,
				subscriptionSendFlag: this.subscriptionSendFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/list`,
				data: params
			}).then(res => {
				// console.log(res)
				this.$emit('getTableData', res.data)
				this.$emit('getParamsData', params)
			}).catch(() => {
				this.$emit('getParamsData', params)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	justify-content: space-between
	padding: 10px 0;
	width :100%;
	line-height :60px;
	border-bottom 1px solid #dce2fd;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		flex-wrap: wrap;
		overflow: hidden
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				display: inline-block;
				text-align: right;
				width: 85px;
				margin-right: 5px
			}
			.name-input {
				width: 160px
			}
		}
	}
	.search-right-wrap {
		width: 200px;
		flex-shrink: 0;
		line-height: 50px
	}
}
</style>
